export const NO_PAYMENT_NECESSARY_TEXT =
  "No payment was necessary for this purchase"
